import { createI18n } from 'vue-i18n'

const loadLocaleMessages = async () => {
  return {
    en: await import('./locales/en.json'),
    zh: await import('./locales/zh.json')
  }
}

const messages = await loadLocaleMessages()

const defaultLang: string = navigator.language.split('-')[0]
const locale = (messages as any)[defaultLang] ? defaultLang : 'en'

const i18n = createI18n({
  legacy: false, // 必须设置为 false 以启用组合式 API
  locale, // 设置默认语言
  fallbackLocale: 'en', // 设置回退语言
  messages // 动态加载语言包
})

export default i18n
